export default __webpack_public_path__ + "static/ThirdBack-99e6c7368dfe57cfda6b4a9288e89956.webp";